export const formateFileSizeMD = (fileSize: number) => {
  const formatedSize = fileSize / (1024 * 1024);
  if (formatedSize > 1) return formatedSize.toFixed(0);
  return formatedSize.toFixed(2);
};
